import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationOverviewSaga";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRange = () => {
  const dispatch = useDispatch();

  const rangeOptions = useSelector((state) => state.multiLocationOverview.rangeOptions);
  const selectedOptions = useSelector((state) => state.multiLocationOverview.selectedRangeOption);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedOptions}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};

export default CustomDateRange;
